import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["name", "fill", "title", "id", "className"];
import * as React from 'react';
import clsx from 'clsx';
import Svg from '../../../components/Svg';
var styles = {
  "root": "ListIcon-root_3hl-r Widget-widget__NYoi Widget-base_2xffH Widget-widgetFixedHeight_2GNLw Widget-widgetFixedWidth_aNuHK Widget-centered_2NDSy"
};
var svgStyles = {
  "root": "SVG-root_1gLEH",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-disabled": "SVG-fill-disabled_2Wv9a SVG-fill-grey_BVkZ6"
};
function ListIcon(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    title = _ref.title,
    id = _ref.id,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var svgClasses = clsx(svgStyles.root, fill && svgStyles["fill-".concat(fill)]);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("span", _extends({
      className: clsx(styles.root, className)
    }, extraProps), /*#__PURE__*/React.createElement(Svg, {
      name: name,
      title: title,
      id: id,
      className: svgClasses
    }))
  );
}
export default ListIcon;